import ApiService from '../../../../services/ApiService'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive.vue'

export default {
  components: {
    InstitutionInactive,
  },

  data: () => ({
    applyRules: true,
    alterDialog: false,
    changedData: false,
    confirmDialog: false,
    deleteDialog: false,
    loading: false,
    institutionInactive: false,
    costCenterLoading: false,
    deleteLoading: false,
    showSuccess: false,
    error: false,
    status: true,
    institutionId: null,
    isEditing: null,
    departmentLoading: false,
    departmentId: 0,
    costCenterId: 0,
    errorMessage: '',
    message: '',
    selected: 0,
    costCenters: [],
    departments: [],
    currentCostCenter: {
      id: 0,
      name: '',
      initials: '',
      status: false,
    },
    currentDepartment: {
      id: 0,
      name: '',
      initials: '',
      status: false,
      costCenter: {
        name: '',
        initials: '',
        status: false,
      },
    },
    apiService: new ApiService(),
    user: {},
    institution: {},
  }),

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.institutionInactive = this.institution.status == 1

    this.searchDepartment()
    this.searchCostCenter()
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.alterDialog = false
      this.close()
    },

    showSuccessAlert(message) {
      this.message = message
      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 1000)
    },

    callConfirmDialog() {
      if (this.isEditing && this.$refs.firstForm.validate()) {
        this.confirmDialog = true
      } else {
        this.submit()
      }
    },

    setActive() {
      this.currentCostCenter.status = 0

      this.submit()
    },

    deleteCostCenter() {
      if (this.currentCostCenter.id != 0) {
        this.deleteDialog = true
      }
    },

    async searchDepartment() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/list/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.departments.unshift({
            id: 0,
            name: 'Selecione o Setor',
            unit: '',
          })
          this.departmentLoading = false
        })
    },

    async searchCostCenter() {
      this.costCenterLoading = true
      await this.apiService
        .get(`costCenter/list/${this.institutionId}`)
        .then((response) => {
          this.costCenters = response.content
          this.costCenters.unshift({
            id: 0,
            name: 'Novo centro de custo',
            unit: '',
          })
          this.costCenterLoading = false
        })
    },

    async getCostCenters() {
      this.costCenterLoading = true

      await this.apiService
        .get(`costCenter/listActive/${this.departmentId}`)
        .then((response) => {
          this.costCenters = response.content
          this.selectedDepartment()
          this.isEditing = false
          this.currentCostCenter.name = null
          this.currentCostCenter.initials = null
          this.costCenterId = null
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.costCenterLoading = false
    },

    selectedDepartment() {
      const department = this.departments.find(
        (department) => department.id === this.departmentId
      )

      if (department.id > 0) {
        //this.isEditing = true;
        this.currentDepartment = department
        this.status = department.status == 0
        this.applyRules = true
        this.selected = department.id

        if (this.costCenterId == 0) {
          this.currentDepartment.costCenter = null
        }
      } else {
        this.selected = 0
        this.currentDepartment = new Object()
        this.currentCostCenter = new Object()
        this.isEditing = false
      }
    },

    selectedCostCenter() {
      const costCenter = this.costCenters.find(
        (costCenter) => costCenter.id === this.costCenterId
      )

      if (costCenter.id > 0) {
        this.isEditing = true
        this.currentCostCenter = costCenter
        this.status = costCenter.status == 0
        this.applyRules = true
      } else {
        this.currentCostCenter = new Object()
        this.isEditing = false
      }
    },

    setInitialCostCenter() {
      this.applyRules = false
      this.costCenterId = 0
      this.currentCostCenter.id = 0
      this.currentCostCenter.name = ''
      this.currentCostCenter.initials = ''
    },

    setInitialDepartment() {
      this.applyRules = false
      this.departmentId = 0
      this.currentDepartment.id = 0
      this.currentDepartment.name = ''
      this.currentDepartment.initials = ''
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        this.loading = true
        this.confirmDialog = false

        if (this.costCenterId == 0) {
          this.currentDepartment.costCenter = null
        }
        let url = 'costCenter/add'

        if (this.isEditing) {
          url = 'costCenter/edit'

          const model = {
            CostCenter: {
              Id: this.currentCostCenter.id,
              Name: this.currentCostCenter.name,
              Initials: this.currentCostCenter.initials,
              InstitutionId: this.institutionId,
              Status: this.currentCostCenter.status,
              DepartmentId: this.departmentId > 0 ? this.departmentId : null,
            },
            Department: {
              Id: this.currentDepartment.id,
              Name: this.currentDepartment.name,
              Initials: this.currentDepartment.initials,
              InstitutionId: this.institutionId,
              Status: this.currentDepartment.status,
            },
            Selected: this.selected,
          }

          await this.apiService
            .post(url, model)
            .then((response) => {
              url == 'costCenter/edit'
                ? this.$toast.success(this.$t('Centro de custo atualizado!'))
                : this.$toast.success(
                    this.$t('Centro de custo criado com sucesso!')
                  )
              this.loading = false
              this.setInitialCostCenter()
              this.setInitialDepartment()
              this.searchCostCenter()
              this.searchDepartment()
              this.showSuccessAlert(response.message)
              setTimeout(() => {
                this.error = false
              }, 2000)
            })
            .catch((err) => {
              this.errorMessage = err.body.message
              this.error = true

              setTimeout(() => {
                this.error = false
              }, 4000)
            })
        } else {
          const model = {
            Id: this.currentCostCenter.id,
            Name: this.currentCostCenter.name,
            Initials: this.currentCostCenter.initials,
            InstitutionId: this.institutionId,
            Status: this.currentCostCenter.status,
            DepartmentId: this.departmentId > 0 ? this.departmentId : null,
          }

          await this.apiService
            .post(url, model)
            .then((response) => {
              url == 'costCenter/edit'
                ? this.$toast.success(this.$t('Centro de custo atualizado!'))
                : this.$toast.success(
                    this.$t('Centro de custo criado com sucesso!')
                  )
              this.loading = false
              this.setInitialCostCenter()
              this.setInitialDepartment()
              this.searchCostCenter()
              this.searchDepartment()
              this.showSuccessAlert(response.message)
              setTimeout(() => {
                this.error = false
              }, 2000)
            })
            .catch((err) => {
              this.errorMessage = err.body.message
              this.error = true

              setTimeout(() => {
                this.error = false
              }, 4000)
            })
        }
        this.loading = false
        this.isEditing = false
        this.applyRules = true
      }
    },

    async remove() {
      this.deleteLoading = true

      await this.apiService
        .delete('costCenter/delete', this.currentCostCenter)
        .then((response) => {
          this.setInitialCostCenter()
          this.setInitialDepartment()
          this.searchCostCenter()
          this.searchDepartment()
          this.showSuccessAlert(response.message)
          this.deleteDialog = false
          this.deleteLoading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
          this.deleteLoading = false
        })

      this.isEditing = false
      this.applyRules = true
    },
  },

  computed: {
    buttonText() {
      if (this.isEditing) {
        return 'Atualizar'
      } else {
        return 'Adicionar'
      }
    },
  },

  watch: {
    currentCostCenter: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
